/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type AuthorizationRoles = typeof AuthorizationRoles[keyof typeof AuthorizationRoles];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthorizationRoles = {
  Tickets: 'Tickets',
  KnowledgeArticles: 'KnowledgeArticles',
  CprRead: 'CprRead',
  CprAdmin: 'CprAdmin',
  SuperUser: 'SuperUser',
  DataRequest: 'DataRequest',
  MarketPartyRegistryRead: 'MarketPartyRegistryRead',
  SimpleDataRequest: 'SimpleDataRequest',
  MarketPartyRegistryReadAll: 'MarketPartyRegistryReadAll',
} as const;
